module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-form-input relative",
    class: [_vm.marginClasses, _vm.sizeClasses, _vm.errorClass]
  }, [(_vm.label && _vm.showLabel) ? _c('BaseLabel', {
    attrs: {
      "size": _vm.size,
      "for": _vm.id,
      "required": _vm.required
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex items-center w-full"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('input', {
    ref: _vm.id,
    staticClass: "sc-purchase-input",
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "aria-label": _vm.label,
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        return _vm.deleteEmpty()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('enter')
      }],
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        return _vm.$emit('change', $event)
      },
      "blur": function($event) {
        return _vm.$emit('blur', $event)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.errorClass.length) ? _c('div', {
    staticClass: "input-error"
  }, [_c('div', {
    staticClass: "has-tooltip"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/Error.svg"),
      "alt": "Error"
    }
  }), _vm._v(" "), (_vm.errorMessageText) ? _c('BaseToolTip', {
    ref: ("tooltip-error-" + _vm.id),
    staticClass: "tooltip-input",
    attrs: {
      "tip": _vm.tip
    }
  }, [_vm._v(_vm._s(_vm.errorMessageText))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "input-loader"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/icons/preloadder.gif"),
      "alt": "Loading..."
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.success) ? _c('div', {
    staticClass: "input-checked"
  }, [_c('div', {
    staticClass: "has-tooltip"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/Checked.svg"),
      "alt": "Checked"
    }
  }), _vm._v(" "), (_vm.successMessage) ? _c('BaseToolTip', {
    ref: ("tooltip-success-" + _vm.id),
    staticClass: "tooltip-input",
    attrs: {
      "tip": _vm.tip
    }
  }, [_vm._v(_vm._s(_vm.successMessage))]) : _vm._e()], 1)]) : _vm._e()])], 1)]), _vm._v(" "), _vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67f7c1c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseInput.vue
// module id = 116
// module chunks = 0